import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-brand-bioderma scrollbar-hidden sticky bottom-16 z-10 flex overflow-auto pt-3 pb-3 md:bottom-0',
    wrap: 'container flex gap-4 md:justify-center',
    anchor:
      'flex-none cursor-pointer pr-4 text-base whitespace-nowrap text-white uppercase hover:opacity-60'
  },
  variants: {
    activeItem: {
      true: {
        anchor: 'opacity-60'
      }
    }
  }
});
